import { Component, createRef } from "react";
import { Alert } from "react-bootstrap";
import Widget from "../common/widget";
import DataFeed from "./data";

export default class TradingViewNode extends Component {
  constructor(props) {
    super(props);
    this.containerRef = createRef();
    this.state = {
      tvError: null,
      missingLib: false
    };
    this.tvWidget = null;
    this.mountedMessage = null;
  }

  componentDidMount() {
    this.mountWidget();
  }

  componentWillUnmount() {
    if (this.tvWidget && this.tvWidget.remove) {
      try { this.tvWidget.remove(); } catch (_) {}
      this.tvWidget = null;
    }
  }

  componentDidUpdate(prevProps) {
    const [ messageValue, warning ] = this.getMessageValue();
    if ( messageValue !== this.mountedMessage ) {
      if (this.tvWidget && this.tvWidget.remove) {
        try { this.tvWidget.remove(); } catch (_) {}
        this.tvWidget = null;
      }
      this.mountWidget();
    }
  }

  getMessageValue() {
    return Widget.loadObjectValue(
      this.props.data.shellInterface, this.props.data.component, "message", "message"
    );
  }

  ensureChartingLibrary(cb) {
    if (window.TradingView && window.TradingView.widget) {
      cb();
      return;
    }

    // Try to load from known local path
    const src = "/libs/charting_library/charting_library.standalone.js";
    const script = document.createElement("script");
    script.src = src;
    script.type = "text/javascript";
    script.onload = () => cb();
    script.onerror = () => {
      this.setState({ missingLib: true });
    };
    document.body.appendChild(script);
  }

  mountWidget() {
    const [ messageValue, warning ] = this.getMessageValue();
    if ( warning ) {
      return;
    }
    const data = messageValue.message.metadata;

    this.mountedMessage = messageValue;

    this.ensureChartingLibrary(() => {
      try {
        const fromTime = Math.floor(data["symbols"][0]["bars"][0]["time"] / 1000);
        const toTime = Math.floor(data["symbols"][0]["bars"].slice(-1)[0]["time"] / 1000);

        const defaultConfig = {
          container: this.getContainerId(),
          locale: "en",
          library_path: "/libs/charting_library/",
          datafeed: new DataFeed(data),
          symbol: data["widget"]["symbol"],
          interval: data["widget"]["interval"],
          fullscreen: false,
          width: "100%",
          height: "100%",
          from: fromTime,
          to: toTime,
          theme: "dark",
          debug: false,
        };

        const config = {...defaultConfig, ...data["widget"]}

        this.tvWidget = new window.TradingView.widget(config);

        // After widget creation, force the time range and configure sessions
        if (this.tvWidget && this.tvWidget.onChartReady) {
          this.tvWidget.onChartReady(() => {
            const chart = this.tvWidget.chart();

            // Set time frame to show extended hours
            chart.setVisibleRange(
              { from: config.from, to: config.to },
              { percentRightMargin: 0 }
            ).then(() => {
              // Draw shapes after the range has been applied
              for (const shape of data["shapes"] || []) {
                chart.createShape(shape["point"], shape["options"]);
              }

              for (const shape of data["multipoint_shapes"] || []) {
                chart.createMultipointShape(shape["points"], shape["options"]);
              }
            });

            // Add studies
            for ( const study of data["studies"] || [] ) {
              chart.createStudy(study.name, false, false, study.inputs);
            }
          });
        }
      } catch (e) {
        this.setState({ tvError: e?.message || String(e) });
      }
    });
  }

  getContainerId() {
    return `tv_widget_${this.props.data.component.id}`;
  }

  renderInner() {
    if (this.state.missingLib) {
      return (
        <Alert variant="info">
          TradingView Charting Library not found.
        </Alert>
      );
    }
    if (this.state.tvError) {
      return (
        <Alert variant="warning">{this.state.tvError}</Alert>
      );
    }

    const [ _, warning ] = this.getMessageValue();
    if ( warning ) {
      return (
        <Alert variant="info">
          {warning}
        </Alert>
      );
    }

    return (
      <div
        id={this.getContainerId()}
        ref={this.containerRef}
        style={{ width: "100%", height: "100%" }}
      />
    );
  }

  render() {
    return (
      <Widget data={this.props.data}>
        {this.renderInner()}
      </Widget>
    );
  }
}
